import { ArticleJsonLd } from "next-seo";
import { generateNextSeo } from "next-seo/pages";
import Head from "next/head";
import SEO, { BASE_URL } from "#next-seo.config";

// updatedAt is optional frontmatter: set it when a post changes in substance, and search engines and the sitemap see the new date.
const BlogSeo = ({ title, summary, publishedAt, updatedAt = undefined, url, image }) => {
  const date = new Date(publishedAt).toISOString();
  const modified = updatedAt ? new Date(updatedAt).toISOString() : date;
  const author = { name: "Samuel Batista", url: BASE_URL };
  const featuredImage = {
    url: image ? `${BASE_URL}${image}` : SEO.openGraph.images[0].url,
    alt: image ? title : SEO.openGraph.images[0].alt
  };

  return (
    <>
      <Head>
        {generateNextSeo({
          title: `${title} – Samuel Batista`,
          description: summary,
          canonical: url,
          openGraph: {
            type: "article",
            article: {
              publishedTime: date,
              modifiedTime: modified
            },
            url,
            title,
            description: summary,
            images: [featuredImage]
          },
          // A post's own image gets the wide card; the small avatar fallback is too small for one.
          twitter: { ...SEO.twitter, cardType: image ? "summary_large_image" : "summary" }
        })}
      </Head>
      <ArticleJsonLd
        type="BlogPosting"
        author={author}
        dateModified={modified}
        datePublished={date}
        description={summary}
        image={[featuredImage.url]}
        publisher={{ ...author, logo: `${BASE_URL}/images/avatar.jpg` }}
        headline={title}
        url={url}
        mainEntityOfPage={url}
      />
    </>
  );
};

export default BlogSeo;
